import React from 'react'
import { injectIntl } from 'react-intl'
import MUIButton from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'

const useStyles = makeStyles((theme) => ({
}))

const Button = ({
	intl,
	textId,
	type,
	size = 'large',
	color = 'primary',
	variant = 'contained',
	onClick = null,
	...other
}) => {
	const classes = useStyles()

	return (
		<MUIButton
			type={type}
			size={size}
			classes={{
				root: classes.root,
				label: classes.label
			}}
			color={color}
			variant={variant}
			onClick={(e) => onClick && onClick(e)}
			{...other}
		>
			{intl.formatMessage({ id: textId })}
		</MUIButton>
	)
}

const enhance = compose(injectIntl)

export default enhance(Button)
